/**
 * 결제 관련 설정
 * PayPal 일시적 비활성화 여부를 환경변수로 제어
 */

/**
 * PayPal 결제 비활성화 여부 확인
 * 환경변수 REACT_APP_PAYPAL_DISABLED가 'true'일 때만 비활성화
 * @returns PayPal이 비활성화되어 있으면 true, 아니면 false
 */
export const isPayPalDisabled = (): boolean => {
  return process.env.REACT_APP_PAYPAL_DISABLED === 'true';
};

